import { motion, useAnimation, Variants } from 'framer-motion';
import { useEffect, useRef } from 'react';

interface RevealProps {
  children: React.ReactNode;
  threshold?: number;
}

const ANIMATION_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const DEFAULT_THRESHOLD = 0.2;

export default function Reveal({ children, threshold = DEFAULT_THRESHOLD }: RevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const controls = useAnimation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          controls.start('visible');
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [controls, threshold]);

  return (
    <motion.div ref={ref} initial="hidden" animate={controls} variants={ANIMATION_VARIANTS}>
      {children}
    </motion.div>
  );
}
